import script from "./kycForm.vue?vue&type=script&setup=true&lang=js"
export * from "./kycForm.vue?vue&type=script&setup=true&lang=js"

import "./kycForm.vue?vue&type=style&index=0&id=91b9427e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91b9427e"]])

export default __exports__